module.exports = __webpack_public_path__ + "static/cosi7-d99834aefa0093d77c8bbd2994250a06.jpg";